<template>
    <div class="list-wrapper">
        <div class="banner">
            <img src="../assets/img/banner.jpg" alt="">
        </div>
        <div class="list-main">
            <div class="list-content">
                <h4 class="list-content-title title">2019名人堂{{title}}候选名单</h4>
                <ul class="list-content-list" v-if="!isLoading && lastList && lastList.length">
                    <li class="list-content-item" v-for="(item, index) in lastList" :key="item._id">
                        <div class="list-content-img" @click="goDetail(item._id)">
                            <img :src="item.data.img + '?imageMogr2/thumbnail/600x450'" alt="">                           
                        </div>
                        <div class="list-content-detail">
                            <p class="list-content-name">{{item.data.title}}</p>
                            <p class="vote-num-box">{{item.count}}票</p>
                            <p class="vote-btn" @click="handleVote(item._id, index)">投票</p>
                        </div>
                    </li>
                </ul>
                <p class="list-content-empty" v-if="isLoading || (!isLoading && lastList && !lastList.length)">{{isLoading ? '数据加载中...' : '没有相关数据...'}}</p>
            </div>
            <div class="list-page">
                <span class="pre-btn" @click="prePage" :class="listOptions.page == 1 && 'disabled'" track="track" track-label="列表页--上一页">上一页</span>
                <span class="next-btn" @click="nextPage" :class="(!nextList || !nextList.length) && 'disabled'" track="track" track-label="列表页--下一页">下一页</span>
            </div>
        </div>
        <div class="back-btn" @click="backHome">返回首页</div>
        <div class="rule list-rule">
            <div class="rule-inner">
                <h4 class="rule-title">活动规则</h4>
                <div class="rule-content">
                  <p class="rule-item"><b>活动主题：</b><br><span>2019名人堂评选活动</span></p>
                  <p class="rule-item"><b>投票方式:</b><br><span>下载封面新闻客户端，进入【我的】-【封蜜club】 “2019名人堂”进行投票</span></p>
                  <p class="rule-item"><span>每个用户每天可给每个榜单投10票。</span></p>
                  <p class="rule-item"><span>禁止刷票等行为，后台发现后立即取消资格。</span></p>
                  <p class="rule-item"><span>读者投票的评选权重占30%，专家评审的评选权重占70%。专家评审有一票否决权</span></p>
                </div>
            </div>
            
        </div>
        <dialog-component :dialogData="dialogData" v-if="dialogData" @setDialogDataEvent="setDialogData"></dialog-component>
        <base-component :baseData="baseData" v-if="baseData"></base-component>
    </div>
</template>

<script>

import BaseComponent from '@/components/Base'
import COVER from '@/utils/COVER'
import DialogComponent from '@/components/Dialog'
import COVERAPP from '@/utils/COVERAPP'

import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            cid: '',
            title: '',
            list: [],
            lastList: null,
            searchVal: '',
            listOptions: {
                cid: '',
                page: 1,// 当前页   默认值-1
                row: 10, // 每一页数量   默认值-10
                keyword: '', //搜索关键词
                field: '', //需要搜索data数据对应的字段
                sort: 'count'
            },
            total: 0,
            isLoading: false,
            nextList: null,
            dialogData: null
        }
    },
    props: ['baseData'],
    computed: {
      ...mapState(['aid', 'bdlist', 'userinfo'])
    },
    components: {
        DialogComponent,
        BaseComponent
    },
    created() {
        this.cid = this.$route.query.id || ''
        this.listOptions.cid = this.cid
        for(let key in this.bdlist) {
          if(this.bdlist[key].id == this.cid) {
            this.title = this.bdlist[key].title
            break;
          }
        }
        this.getVoteData()
    },
    mounted() {
        if(!this.userinfo.token) {
            this.getUserInfon() 
        } 
    },
    methods: {
        ...mapActions([
            'getUserinfoAsync'
        ]),
        getUserInfon() {
            this.getUserinfoAsync(); 
        },
        setDialogData() {
            this.dialogData = null
        },
        getVoteData() {
            if(this.isLoading) return
            this.isLoading = true
            COVER.$request('/vote/list', this.listOptions).then((res) => {
                this.isLoading = false
                if(res.errno == 0 && res.data) {
                    let data = res.data
                    this.list.push(...data)
                    this.lastList = data || []
                    this.nextList = null
                    if(data.length < 10) {
                        return
                    }
                    let nextOptions = JSON.parse(JSON.stringify(this.listOptions))
                    nextOptions.page++
                    COVER.$request('/vote/list', nextOptions).then((nextRes) => {
                      if(nextRes.errno == 0 && nextRes.data) {
                        this.nextList = nextRes.data || []
                      }
                    })
                }
            }).catch(() => {
                this.isLoading = false
            })
        },
        prePage() {
            this.listOptions.page > 1 && this.listOptions.page-- && this.getVoteData()
        },
        nextPage() {
            this.nextList && this.nextList.length && this.listOptions.page++ && this.getVoteData()
        },
        handleVote(id, index) {
            if(!this.userinfo.token) {
                this.dialogData = {
                    message: '参与活动，需登录!',
                    btns: [
                        {
                            text: '去登录',
                            className: 'login-btn'
                        },
                        {
                            text: '取消',
                            className: 'close-btn'
                        }
                    ]
                }
                return;
            }
            this.dialogData = {
                message: '投票中，请稍后...'
            }
            COVER.$request('/vote', {
                cid: this.cid,
                userid: this.userinfo.token,
                vid: id,
                userinfo: JSON.stringify(this.userinfo),
                aid: this.aid
            }).then((res) => {
                if(res.errno == 0) {
                    this.dialogData = {
                        message: '投票成功',
                        btns: [
                            {
                                text: '确认'
                            }
                        ]
                    }
                    this.lastList[index].count++
                } else {
                    this.dialogData = {
                        message: res.errmsg || '投票失败，请重试',
                        btns: [
                            {
                                text: '确认'
                            }
                        ]
                    }
                }   
            })
        },
        goDetail(id) {
            this.$router.push(`/detail?id=${this.cid}&vid=${id}`)
        },
        backHome() {
          this.$router.push(`/`)
        }
    }
}
</script>

<style lang="less" scoped>
    .list-wrapper {
      background: #fff;
      position: relative;
    }
    .banner {
        height: 7.5rem;
    }
    .title{
        font-weight: bold;
        font-size: .574074rem;
        color: #383838;
        letter-spacing: 0.1rem;
        line-height: 1.3;
        text-align: center;
        padding-bottom: .185185rem;
        position: relative;
        margin: 0 0 .814815rem;
    }
    .title::after{
        content: '';
        position: absolute;
        left: 50%;
        margin-left: -0.296296rem;
        bottom: 0;
        width: .592593rem;
        height: .111111rem;
        background-color: #db332a;
    }
    .list-main{
        background-color: #fff;
        border-radius: 0.15rem;
        box-shadow: 0 0 .277778rem #eeeef2;
        padding: 1.018519rem 0 1.12963rem;
        margin: 0 .185185rem .925926rem;
        position: relative;
    }
    .list-content-title{
        font-size: 0.48rem;
        letter-spacing: 0;
        padding-bottom: 0.22rem;
        margin-bottom: .740741rem;
    }
    .list-content-list{
        padding: 0 0 .509259rem;
        font-size: 0;
        letter-spacing: -4px;
        text-align: center;
    }
    .list-content-empty {
        font-size: 0.4rem;
        text-align: center;
        padding: 0.8rem 0;
    }
    .list-content-item{
        width: 3.962963rem;
        letter-spacing: 0;
        display: inline-block;
        vertical-align: top;
        margin-bottom: .62963rem;
    }
    .list-content-item:nth-of-type(2n){
        margin-left: 1.037037rem;
    }
    .list-content-img{
        border: 2px solid #e30504;
        border-radius: 0.2rem;
        overflow: hidden;
        box-sizing: border-box;
        height: 3rem;
        img {
          position: relative;
          display: block;
          top: 50%;
          transform: translateY(-50%);
        }
    }
    .list-content-img a{
        display: block;
    }
    .list-content-detail{
        padding-top: .185185rem;
        text-align: center;
    }
    .list-content-name{
        color: #383838;
        font-size: .444444rem;
        font-weight: bold;
        line-height: 1.4;
        margin:  0 0 .1rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 1.2rem;
        overflow: hidden;
    }
    .list-content-post{
        color: #383838;
        font-size: .333333rem;
        line-height: 1.3;
        margin: 0 0 0.1rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .list-sj .list-content-name{
        font-size: .37037rem;    
        white-space: normal;
        line-height: 1.3;
        height: .925926rem;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .vote-num-box{
        font-size: .444444rem;
        color: #e30504;
        margin: 0 0 .148148rem;
        font-weight: 600;
    }
    .vote-btn{
        font-size: .444444rem;
        color: #fff;
        font-weight: bold;
        width: 3.148148rem;
        height: 1.092593rem;
        border: 2px solid #f5df78;
        padding: 0.2rem 0;
        line-height: 1.3;
        text-align: center;
        background: #e30504;
        border-radius: 0.8rem;
        margin: 0 auto;
        box-shadow: 0 .185185rem .462963rem #fac3c3;
        letter-spacing: 0.1rem;
        box-sizing: border-box;
    }
    .vote-btn.voted{
        color: #db332a;
        border: 2px solid #db332a;
        background: #fff;
    }
    .list-page{
        padding: 0 .37037rem;
        overflow: hidden;
    }
    .list-page span{
        font-size: .444444rem;
        color: #db332a;
        font-weight: bold;
        line-height: 1.3;
        height: 1.018519rem;
        text-align: center;
        width: 50%;
        box-sizing: border-box;
        display: block;
        border: 2px solid #db332a;
        float: left;
        padding: .2rem 0;
        letter-spacing: 0.1rem;
    }
    .list-page span.disabled{
        color: #bababc;
    }
    .list-page .pre-btn{   
        border-top-left-radius: 0.8rem;
        border-bottom-left-radius: 0.8rem;
        border-right-width: 1px;
    }
    .list-page .next-btn{  
        border-top-right-radius: 0.8rem;
        border-bottom-right-radius: 0.8rem;
        border-left-width: 1px;
    }
    .back-btn {
      display: block;
      height: 0.7rem;
      padding: .12rem 0;
      color: #fff;
      letter-spacing: .04rem;
      font-weight: 700;
      font-size: .44444rem;
      margin: 0 .2777778rem 0.925926rem;
      background: #e30504;
      box-shadow: 0 0.046rem 0.23rem #f9b2b2;
      border: 2px solid #f5df78;
      position: relative;
      border-radius: 0.7rem;
      text-align: center;
      line-height: 0.68rem;
    }
</style>